import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "./sentry.js";
import App from "./App"; // Assuming App handles routing

/*
 * Weeks run Monday–Sunday. Ant's DatePicker takes its week start from the dayjs
 * locale, so without this its week picker would highlight Sun–Sat while the
 * appointments calendar grid draws Mon–Sun, and picking a week would land you
 * on the wrong one.
 */
dayjs.extend(updateLocale);
dayjs.updateLocale("en", { weekStart: 1 });

if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const resizeObserverLoopErr = /ResizeObserver loop/;
window.addEventListener(
  "error",
  (event) => {
    if (resizeObserverLoopErr.test(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App /> {/* Assuming App handles routing */}
  </StrictMode>
);
